/**
 * Retorna a URL absoluta da imagem. Se for um path relativo (ex.: /uploads/...),
 * adiciona o base URL do backend para carregar corretamente.
 */
export function getImageUrl(url: string | null | undefined): string {
	if (!url || typeof url !== 'string') return '';
	if (url.startsWith('http://') || url.startsWith('https://')) return url;
	const base = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/$/, '');
	if (!base) return url;
	return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`;
}
